import i18n from "@/i18n";
import { AuthNavigationVue } from "fs-pb-vue2/vueModels/navigation/AuthNavigationVue";
import { appConfig } from "fs-pb-vue2/config";

export class AuthNavigationVueSNB extends AuthNavigationVue {

  get windowWidthCalc(): number {
    return window.innerWidth;
  }

  /** Список ссылок в меню */
  links: Array<any> = [
    {
      title: i18n.t("auth.nav.office"),
      url: appConfig.officesUrl,
      exact: true
    },
    {
      title: i18n.t("auth.nav.atm"),
      url: appConfig.atmUrl
    },
    {
      title: i18n.t("auth.nav.contacts"),
      url: appConfig.contactsUrl
    }
  ];
}